module.exports = __webpack_public_path__ + "media/images/icon-login-facebook@3x-f13408c55b5afeb61f01f0b461fa4b6d.png";